import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useGetAllPendingStatusList } from "src/pages/Configuration/Parameters/Others/PendingStatus/api/getAllPendingStatusList";
import { useGetAllProvidersList } from "src/pages/Configuration/Parameters/Others/Providers/api/getAllProvidersList";
import { useGetAllUsedByList } from "src/pages/Configuration/Parameters/Lines/UsedBy/api/getAllUsedByList";
import { useGetAllLineTypesList } from "src/pages/Configuration/Parameters/Lines/LineTypes/api/getAllLineTypesList";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";


const CreatePhoneLineForm = ({ initialValues, onSubmit }: CreatePhoneLineFormProps) => {
  const { t } = useTranslation();
  const getAllPendingStatusListQuery = useGetAllPendingStatusList();
  const getAllProvidersListQuery = useGetAllProvidersList(); 
  const getAllUsedByListQuery = useGetAllUsedByList(); 
  const getAllLineTypesListQuery = useGetAllLineTypesList();

  const validationSchema = Yup.object({
    unitID: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    pendingStatusID: Yup.string().test({
      name: "exclusiveFields",
      exclusive: true,
      test: function(value) {
        const { usedByID } = this.parent;
        return !(value && usedByID && value.trim() !== "" && usedByID.trim() !== "");
      },
      message: "Επιλέξτε ένα απο τα δύο πεδία",
    }).test({
      name: "atLeastOneField",
      test: function(value) {
        const { usedByID } = this.parent;
        return value || usedByID;
      },
      message: "Τουλάχιστον ένα από τα πεδία 'Εκκρεμότητα' ή 'Χρήση Απο' πρέπει να επιλεγεί",
    }),
    usedByID: Yup.string().test({
      name: "exclusiveFields",
      exclusive: true,
      test: function(value) {
        const { pendingStatusID } = this.parent;
        return !(value && pendingStatusID && value.trim() !== "" && pendingStatusID.trim() !== "");
      },
      message: "Επιλέξτε ένα απο τα δύο πεδία",
    }).test({
      name: "atLeastOneField",
      test: function(value) {
        const { pendingStatusID } = this.parent;
        return value || pendingStatusID;
      },
      message: "Τουλάχιστον ένα από τα πεδία 'Εκκρεμότητα' ή 'Χρήση Απο' πρέπει να επιλεγεί",
    }),
    /* bulkPhoneNumbersAdd: Yup.number()
      .min(1, "Το πεδίο πρέπει να έχει τιμή τουλάχιστον 1")
      .max(300, "Το πεδίο πρέπει να έχει τιμή μέχρι 300")
      .integer("Το πεδίο πρέπει να είναι ακέραιος αριθμός") */
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, getFieldProps }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>

             <UnitsSelectionDropdown errors={errors} touched={touched} />

              <Col xs={6}>
                <label className="form-label">
                  {t("Αριθμός Αίτησης")}
                </label>
                <Field
                  name="applProtocolNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="applProtocolNumber"
                  
                />
                <div className="text-danger">
                  {errors.applProtocolNumber && touched.applProtocolNumber && (
                    <div>{errors.applProtocolNumber}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Αίτησης")}
                </label>
                <Field 
                  name="applDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.applDate && touched.applDate && (
                    <div> {errors.applDate}</div>
                  )}
                </div>               
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Επίσημη Ημερομηνία Αίτησης")}
                </label>
                <Field 
                  name="offApplDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.offApplDate && touched.offApplDate && (
                    <div>{errors.offApplDate}</div>
                  )}
                </div>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Ημερομηνία Παράδοσης")}
                </label>
                <Field 
                  name="deliveryDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.deliveryDate && touched.deliveryDate && (
                    <div>{errors.deliveryDate}</div>
                  )}
                </div>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Εκκρεμότητα")}*`}
                </label>
                <Field
                  as="select"
                  name="pendingStatusID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="pendingStatusID"
                >
                <option value="">{t("Επιλέξτε Εκκρεμότητα")}</option>
                {getAllPendingStatusListQuery.data &&
                  getAllPendingStatusListQuery.data.map((pending) => (
                    <option key={pending.id} value={pending.id}>
                      {pending.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.pendingStatusID && touched.pendingStatusID && (
                    <div>{errors.pendingStatusID}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Πάροχος")}`}
                </label>
                <Field
                  as="select"
                  name="providerID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="providerID"
                >
                <option value="">{t("Επιλέξτε Πάροχο")}</option>
                {getAllProvidersListQuery.data &&
                  getAllProvidersListQuery.data.map((provider) => (
                    <option key={provider.id} value={provider.id}>
                      {provider.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.providerID && touched.providerID && (
                    <div>{errors.providerID}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Τύπος Γραμμής")}`}
                </label>
                <Field
                  as="select"
                  name="lineTypeID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="lineTypeID"
                >
                <option value="">{t("Επιλέξτε τύπο Γραμμής")}</option>
                {getAllLineTypesListQuery.data &&
                  getAllLineTypesListQuery.data.map((lineType) => (
                    <option key={lineType.id} value={lineType.id}>
                      {lineType.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.lineTypeID && touched.lineTypeID && (
                    <div>{errors.lineTypeID}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Χρήση Απο")}*`}
                </label>
                <Field
                  as="select"
                  name="usedByID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="usedByID"
                >
                <option value="">{t("Επιλέξτε Χρήση από")}</option>
                {getAllUsedByListQuery.data &&
                  getAllUsedByListQuery.data.map((usedby) => (
                    <option key={usedby.id} value={usedby.id}>
                      {usedby.description}
                    </option>
                  ))}
              </Field>
                <div className="text-danger">
                  {errors.usedByID && touched.usedByID && (
                    <div>{errors.usedByID}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Περιγραφή Γραμμής")}`}
                </label>
                <Field
                  name="descline"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="descline"
                 
                />
                <div className="text-danger">
                  {errors.descline && touched.descline && (
                    <div>{errors.descline}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Εμπορική")}
                </label>
                <Field
                  type="checkbox"
                  name="isEmporiki"
                  field="isEmporiki"
                  className="mt-3 mb-3"
                />
                <div className="text-danger">
                  {errors.isEmporiki && touched.isEmporiki && (
                    <div>{errors.isEmporiki}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Citibank")}`}
                </label>
                <Field
                  type="checkbox"
                  name="isCiti"
                  field="isCiti"
                  className="mt-3 mb-3"
                />
                <div className="text-danger">
                  {errors.isCiti && touched.isCiti && (
                    <div>{errors.isCiti}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Κωδικός SAP")}
                </label>
                <Field
                  type="text"
                  name="sapCode"
                  field="sapCode"
                  className="form-control"
                />
                <div className="text-danger">
                  {errors.sapCode && touched.sapCode && (
                    <div>{errors.sapCode}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Αριθμός Κλήσης")}
                </label>
                <Field
                  type="text"
                  name="phoneNumber"
                  field="phoneNumber"
                  className="form-control"
                />
                <div className="text-danger">
                  {errors.phoneNumber && touched.phoneNumber && (
                    <div>{errors.phoneNumber}</div>
                  )}
                </div>
              </Col>

             {/*  <Col xs={6}>
                <label className="form-label">
                  {t("Μαζική προσθήκη επιπλέον αριθμών *(Max 300)")}                  
                </label>
                <Field
                  type="text"
                  name="bulkPhoneNumbersAdd"
                  field="bulkPhoneNumbersAdd"
                  className="form-control"
                />
                <div className="text-danger">
                  {errors.bulkPhoneNumbersAdd && touched.bulkPhoneNumbersAdd && (
                    <div>{errors.bulkPhoneNumbersAdd}</div>
                  )}
                </div>
              </Col> */}

              <Col xs={12}>
                <label className="form-label">
                  {t("Σχόλια")}
                </label>
                <Field
                  type="text"
                  name="comments"
                  field="comments"
                  className="form-control"
                  as="textarea"
                />
                <div className="text-danger">
                  {errors.comments && touched.comments && (
                    <div>{errors.comments}</div>
                  )}
                </div>
              </Col>
          
            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {t("Δημιουργία")}
            </Button>
          </div>
        </Form>
    )}
    </Formik>
  )
}

export default CreatePhoneLineForm;

type CreatePhoneLineFormProps = {
    initialValues: ICreatePhoneLineForm;
    onSubmit: (
      values: ICreatePhoneLineForm,
      formikHelpers: FormikHelpers<ICreatePhoneLineForm>
    ) => void;
  };